import { Grid, Typography } from '@mui/material'
import MonetaryFormat from 'components/MonetaryFormat/MonetaryFormat'

interface IPaymentAccountDetail {
    paymentAccountName: string
    paymentAccountBalance: number
}
function PaymentAccountDetail({
    paymentAccountName,
    paymentAccountBalance,
}: IPaymentAccountDetail) {
    return (
        <Grid item container>
            <Typography color="primary">Payment on Account</Typography>
            <Typography color="primary" px={1} fontWeight={700}>
                {paymentAccountName} :{' '}
            </Typography>
            <Typography color="primary">
                <MonetaryFormat
                    isOnlyString
                    value={paymentAccountBalance}
                    color="text"
                    forceMonetaryFormat="plus"
                    marginX={1}
                />
            </Typography>
        </Grid>
    )
}
export default PaymentAccountDetail
